import React, { useState, useEffect } from "react";
import { Accordion, Card, Button, Form, Spinner } from "react-bootstrap";
import fire from "../../Configs/firebase";

function OutstationPaymentsTab({
  apiData = {},
  order_id,
  driver_id,
  status,
  orderDeliveryDate,
  handleTransporterSubmit,
  refreshApiData
}) {
  const isEditable = status === "delivered" || status === "partially-delivered";
  const baseOrderId = order_id.split("-").slice(0, 2).join("/");
//   const filteredData = (apiData || []).filter(order => order.order_id === baseOrderId);

  const [formState, setFormState] = useState({
    transporterId: "",
    transporterName: "",
    transporterCost: "",
    receiptFile: null,
    receiptName: "",
    selectedDate: orderDeliveryDate//new Date().toISOString().split("T")[0],
  });

  const [transporterOptions, setTransporterOptions] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [filteredData, setFilteredData] = useState([]);

  useEffect(() => {
    const baseOrderId = order_id.split("-").slice(0, 2).join("/");
    const filtered = (apiData || []).filter(order => order.order_id === baseOrderId);
    // console.log("🎯 Filtered data:", filtered);
    setFilteredData(filtered);
    }, [apiData, order_id]);

// console.log("📦 OutstationPaymentsTab rendered with props:", {
//   apiData,
//   order_id,
//   driver_id
//});

//  useEffect(() => {
//   console.log("🔄 useEffect triggered in child with apiData:", apiData);
// }, [apiData]);

  useEffect(() => {
    fire.database().ref("Driver_Company").once("value")
      .then(snapshot => {
        if (snapshot.exists()) {
          const data = snapshot.val();
          const companies = Object.keys(data).map(key => ({
            transporter_id: key,
            ...data[key]
          }));

          const filtered = companies.filter(
            t => t.status?.toLowerCase() === "active" && t.type?.toLowerCase() === "outstation"
          );

          setTransporterOptions(filtered);
        }
      })
      .catch(error => {
        console.error("Error loading transporters", error);
      });
  }, []);

  const handleInputChange = (field, value) => {
    setFormState(prev => ({ ...prev, [field]: value }));
  };

  const handleTransporterChange = (e) => {
    const selectedId = e.target.value;
    const selectedTransporter = transporterOptions.find(t => t.transporter_id === selectedId);
    setFormState(prev => ({
      ...prev,
      transporterId: selectedId,
      transporterName: selectedTransporter?.transporter_name || ""
    }));
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file && file.type.startsWith("image/")) {
      handleInputChange("receiptFile", file);
      handleInputChange("receiptName", file.name);
    } else {
      alert("Only image files are allowed.");
      e.target.value = null;
    }
  };

  const handleSubmit = async (orderId) => {
    const {
      transporterId,
      transporterName,
      transporterCost,
      receiptFile,
      selectedDate
    } = formState;

    if (!transporterId || !transporterCost || !receiptFile) {
      alert("Please fill all required fields.");
      return;
    }

    const formattedOrderId = formatOrderId(orderId);
    setIsSubmitting(true);

    try {
      await handleTransporterSubmit({
        transporterId,
        transporterName,
        transporterCost,
        receipt: receiptFile,
        formattedOrderId,
        selectedDate,
        route_Details: { driver_id }
      });

      // Reset form after submission
      setFormState({
        transporterId: "",
        transporterName: "",
        transporterCost: "",
        receiptFile: null,
        receiptName: "",
        selectedDate: orderDeliveryDate//new Date().toISOString().split("T")[0]
      });
       setTimeout(() => {
         window.location.reload();
        }, 1000);

    } catch (error) {
      console.error("Error while submitting transporter data:", error);
    } finally {
      setIsSubmitting(false);
    }
  };

  const formatOrderId = (orderId) => {
    const parts = orderId.split("-");
    return parts.length >= 2 ? `${parts[0]}/${parts[1]}` : orderId;
  };

  //if (!driver_id.startsWith("83")) return null;

  return (
    <Form>
      <Accordion defaultActiveKey="0">
        {(filteredData.length > 0 ? filteredData : [{ order_id: baseOrderId }]).map((order, index) => {
          const needsForm = !order.transporter_name || !order.transporter_cost || !order.receipt;

          return (
            <Card key={index}>
              <Card.Header>
                <Accordion.Toggle as={Button} variant="link" eventKey={index.toString()}>
                  Outstation Payment Details - {order.order_id}
                </Accordion.Toggle>
              </Card.Header>
              <Accordion.Collapse eventKey={index.toString()}>
                <Card.Body>

                  {isSubmitting && (
                    <div className="d-flex align-items-center mb-3">
                      <Spinner animation="border" variant="primary" />
                      <span className="ms-2">Saving transport details...</span>
                    </div>
                  )}

                  {/* Transporter Name */}
                  {order.transporter_name ? (
                    <Form.Group>
                      <Form.Label>Transporter Name</Form.Label>
                      <Form.Control type="text" value={order.transporter_name} readOnly />
                    </Form.Group>
                  ) : (
                    <Form.Group>
                      <Form.Label>Transporter Name *</Form.Label>
                      <select
                        className="form-control"
                        value={formState.transporterId}
                        onChange={handleTransporterChange}
                        disabled={!isEditable}
                        required
                      >
                        <option value="">Select Transporter</option>
                        {transporterOptions.map(t => (
                          <option key={t.transporter_id} value={t.transporter_id}>
                            {t.transporter_name}
                          </option>
                        ))}
                      </select>
                    </Form.Group>
                  )}

                  {/* Transporter Cost */}
                  {order.transporter_cost ? (
                    <Form.Group>
                      <Form.Label>Transporter Cost</Form.Label>
                      <Form.Control type="text" value={order.transporter_cost} readOnly />
                    </Form.Group>
                  ) : (
                    <Form.Group>
                      <Form.Label>Transporter Cost *</Form.Label>
                      <Form.Control
                        type="number"
                        placeholder="Enter transporter cost"
                        min="0"
                        value={formState.transporterCost}
                        onChange={(e) => handleInputChange("transporterCost", e.target.value)}
                        onWheel={(e) => e.target.blur()}
                        onKeyDown={(e) => e.key === "-" && e.preventDefault()}
                        disabled={!isEditable}
                        required
                      />
                    </Form.Group>
                  )}

                  {/* Receipt Upload */}
                  {order.receipt ? (
                    <Form.Group>
                      <Form.Label>Receipt</Form.Label>
                      <br />
                      <a href={order.receipt} target="_blank" rel="noopener noreferrer">
                        View Receipt
                      </a>
                    </Form.Group>
                  ) : (
                    <Form.Group>
                      <Form.Label>Upload Receipt (Image)*</Form.Label>
                      <Form.Control
                        type="file"
                        accept="image/*"
                        onChange={handleFileChange}
                        disabled={!isEditable}
                        required
                      />
                      {formState.receiptName && (
                        <small className="text-muted">Selected file: {formState.receiptName}</small>
                      )}
                    </Form.Group>
                  )}

                  {/* Submit Button */}
                  {needsForm && (
                    <Button
                      variant="primary"
                      onClick={() => handleSubmit(order.order_id)}
                      disabled={isSubmitting || !isEditable}
                    >
                      {isSubmitting ? "Submitting..." : "Submit Missing Details"}
                    </Button>
                  )}
                </Card.Body>
              </Accordion.Collapse>
            </Card>
          );
        })}
      </Accordion>
    </Form>
  );
}

export default OutstationPaymentsTab;